// 设置

// 用户管理
const UserManagement = () => import(/* webpackChunkName: "UserManagement" */ '@/components/setting/user-management.vue')

// 用户详情
const UserDetails = () => import(/* webpackChunkName: "UserDetails" */ '@/components/setting/user-details.vue')

// 角色管理
const RoleManagement = () => import(/* webpackChunkName: "RoleManagement" */ '@/components/setting/role-management.vue')

// 用户详情
const RoleDetails = () => import(/* webpackChunkName: "RoleDetails" */ '@/components/setting/role-details.vue')

export default [
  // 用户管理路由
  {
    path: '/setting/UserManagement',
    name: 'UserManagement',
    component: UserManagement
  },
  {
    path: '/setting/UserDetails',
    name: 'UserDetails',
    component: UserDetails
  },
  {
    path: '/setting/RoleManagement',
    name: 'RoleManagement',
    component: RoleManagement
  },
  {
    path: '/setting/RoleDetails',
    name: 'RoleDetails',
    component: RoleDetails
  }
]



// WEBPACK FOOTER //
// ./src/router/index-setting.js